export const useFetchParams = (url, name) => {
  const paramList = url.split("/");
  const index = paramList.indexOf(name);
  const params = paramList.slice(index + 1, paramList.length);
  return params;
};
export { useFetchParams as fetchParams };
